/**
 * 错误类型枚举
 */
export enum ErrorType {
  // HTTP 状态码错误（4xx、5xx），请求到达服务器但处理失败
  HTTP_ERROR = 'http_error',

  // 网络连接错误（通用，兜底）
  NETWORK_ERROR = 'network_error',

  // chat 请求 - 建立流阶段网络错误
  NETWORK_ERROR_CHAT_FETCH = 'network_error_chat_fetch',

  // chat 请求 - 流传输阶段网络错误
  NETWORK_ERROR_CHAT_STREAM = 'network_error_chat_stream',

  // resume 请求 - 建立流阶段网络错误
  NETWORK_ERROR_RESUME_FETCH = 'network_error_resume_fetch',

  // resume 请求 - 流传输阶段网络错误
  NETWORK_ERROR_RESUME_STREAM = 'network_error_resume_stream',

  // SSE 流错误
  SSE_AGENT_EVENT = 'sse_agent_event',
  SSE_ERROR_EVENT = 'sse_error_event',

  // 内容过滤错误
  CONTENT_FILTER = 'content_filter',

  // 积分不足错误
  CREDIT_ERROR = 'credit_error',

  // 未知错误，用于兜底场景
  UNKNOWN_ERROR = 'unknown_error',
}

/** 后端接口业务状态码 */
export enum BusinessErrorCode {
  /** 用户未登录 */
  UserNotLoggedIn = 100007,
}

export const BUSINESS_ERROR_MESSAGE_KEYS: Record<BusinessErrorCode, string> = {
  [BusinessErrorCode.UserNotLoggedIn]: 'user.errors.userNotLoggedIn',
};
